<template>
  <base-dialog v-model="show" @close="close" :loading="loading" fullscreen>
    <template v-slot:title> Danh sách ký hiệu </template>
    <template #content>
      <v-row class="ma-0 overflow-hidden full-height">
        <v-col cols="4" md="3" class="full-height">
          <div class="tree-list overflow-auto full-height">
            <div class="text-h6">
              Thư mục ký hiệu
            </div>
            <div v-if="tree.loading" class="loading-container">
              <loading-component />
            </div>
            <ul v-else class="folder-list-icon">
              <icon-folder-node
                v-for="folder in tree.items"
                :key="folder.id"
                :value="folder"
                :select-id="
                  current_folder &&
                    current_folder.info &&
                    current_folder.info.id
                "
                @click:select="onSelectFolder"
              />
            </ul>
          </div>
        </v-col>
        <v-divider vertical></v-divider>
        <v-col cols="8" md="9" class="full-height">
          <div class="icon-list overflow-auto full-height">
            <div v-if="!current_folder" class="text-subtitle-1">
              Lựa chọn thư mục ở bên tay phải trước
            </div>
            <div
              v-else-if="current_folder.loading"
              class="loading-container full-height"
            >
              <loading-component />
            </div>
            <div v-else>
              <div class="text-h5">
                Thông tin thư mục: <b>{{ current_folder.info.name }}</b>
              </div>
              <div
                v-if="!current_folder.items || current_folder.items.length < 1"
                class="text-subtitle-1"
              >
                Thự mục không có dữ liệu
              </div>
              <div v-else>
                <div class="icon-container">
                  <div
                    v-for="icon in current_folder.items"
                    :key="icon.id"
                    class="icon-item"
                  >
                    <v-hover v-slot:default="{ hover }">
                      <v-card
                        @click="onSelectItem(icon)"
                        :elevation="hover ? 1 : 0"
                        outlined
                        tile
                      >
                        <v-icon size="100"> mdi-format-font</v-icon>
                        <v-tooltip bottom color="primary">
                          <template v-slot:activator="{ on, attrs }">
                            <div
                              v-bind="attrs"
                              v-on="on"
                              class="pa-2 text-truncate full-width"
                              >{{ icon.name }}</div
                            >
                          </template>
                          <span>{{ icon.name }}</span>
                        </v-tooltip>
                      </v-card>
                    </v-hover>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </template>
  </base-dialog>
</template>

<script>
import IconFolderNode from './icon-folder-node.vue'
import { API_SYMBOL } from '@api'
export default {
  components: { IconFolderNode },
  props: {},
  data: () => ({
    show: false,
    loading: false,
    tree: { loading: false, items: [] },
    current_folder: null,
  }),
  computed: {},
  methods: {
    open() {
      this.show = true
      this.loading = false
      this.getFolder(this.tree)
    },
    async getFolder(item, param = {}) {
      item.loading = true
      param.type = 'font'

      try {
        let res = await API_SYMBOL.getFolderItems(param)
        this.$set(item, 'items', res.data)
      } finally {
        item.loading = false
      }
    },
    async getData(item, params) {
      return API_SYMBOL.getFolderItems(params)
    },
    async onSelectFolder(folder) {
      this.current_folder = { loading: false, info: folder, items: [] }
      try {
        this.current_folder.loading = true
        const res = await API_SYMBOL.getFolderItems({
          parent_id: folder.id,
          type: 'font',
        })
        let folders = [],
          icons = []
        res.data.forEach((x) => {
          if (x.type == 'font-folder') {
            folders.push(x)
          } else {
            icons.push(x)
          }
        })
        this.$set(folder, 'children', folders)
        this.current_folder.items = icons
      } finally {
        this.current_folder.loading = false
      }
    },
    close() {
      this.show = false
      this.loading = false
      this.current_folder = null
    },
    onSelectItem(icon) {
      this.$emit('submit', icon)
      this.close()
    },
  },
}
</script>

<style scoped>
.icon-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
}
.icon-item {
  flex: 0 0 25%;
  text-align: center;
  padding: 16px;
  max-width: 25%;
}
</style>
